import useSWR from "swr";
import { useApiClient } from "./useApiClient";
import { type IPrefecture } from "@/types/prefectures";

interface IUsePrefecturesReturnType {
  prefectures: IPrefecture[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * 都道府県マスタを取得するカスタムフック
 * SWRを使用してキャッシュと再検証を管理
 */
export const usePrefectures = (): IUsePrefecturesReturnType => {
  const { apiClient } = useApiClient();

  const fetcher = async (url: string): Promise<IPrefecture[]> => {
    const { data } = await apiClient.get<IPrefecture[]>(url);
    return data;
  };

  const { data, error, isLoading } = useSWR<IPrefecture[], Error>(
    "/general/prefecture",
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    prefectures: data ?? [],
    isLoading,
    isError: Boolean(error),
  };
};
